<template>
    <div>
        <div class="scroll-table">
            <div class="table-responsive text-nowrap">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="th-first">{{ __("note_title") }}</th>
                            <th class="text-truncate text-wrap">
                                {{ __("added_date") }}
                            </th>
                            <th class="text-truncate text-wrap">
                                {{ __("user") }}
                            </th>
                            <th class="th-before th-last"></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            class="row-odd"
                            v-for="note in notes"
                            :key="note.id"
                        >
                            <td class="td-padding max-w-200 td-word-break">
                                {{ note.title }}
                            </td>
                            <td class="td-padding">{{ note.created_at }}</td>
                            <td class="td-padding">{{ note.author }}</td>
                            <td class="text-right table-icons">
                                <a
                                    href=""
                                    class="tooltip-more"
                                    title=""
                                    :data-original-title="__('show')"
                                    @click.prevent="openPreviewModal(note)"
                                    ><i class="fa fa-eye"></i
                                ></a>
                                <a
                                    :href="getToggleRoute(note.id)"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title=""
                                    :data-original-title="
                                        note.hidden
                                            ? __('discover')
                                            : __('hide')
                                    "
                                    v-if="!preview"
                                >
                                    <i
                                        class="fas"
                                        :class="
                                            note.hidden
                                                ? 'fa-check-circle'
                                                : 'fa-times-circle'
                                        "
                                    ></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <modal-note-preview
            ref="note_preview_modal"
            id="note_preview_modal"
            :title="__('show_note')"
        />
    </div>
</template>

<script>
import ModalNotePreview from "../../modals/ModalNotePreview.vue";
export default {
    components: { ModalNotePreview },
    props: {
        notes: {
            type: Array,
            default: () => []
        },
        toggleRoute: {
            type: String,
            default: ""
        },
        preview: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        openPreviewModal(note) {
            this.$refs.note_preview_modal.openModal(note);
        },
        getToggleRoute(note_id) {
            return `${this.toggleRoute}/${note_id}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.td-word-break {
    word-wrap: break-word;
    white-space: normal;
}
</style>
